export default __webpack_public_path__ + "static/imgHome4-e598585e08a39a256ef29074db2591ad.png";